import { ClientType } from '../../common/types/client';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import { JSX } from 'react';
import SelectClientsDialog from '../../clients/selectClientsDialog';

/**
 * Cell for editing representative roleplayer for a party
 */
const DataGridEditPartyRepresentativeCell = ({
  id,
  value,
  field,
}: GridRenderEditCellParams): JSX.Element => {
  const apiRef = useGridApiContext();
  const handleClose = (selectedClientIds?: number[]): void => {
    const selectedClientId = selectedClientIds?.[0];
    if (selectedClientId) {
      apiRef.current.setEditCellValue({ id, field, value: selectedClientId });
      apiRef.current.stopCellEditMode({ id, field });
    } else {
      // If no client was selected, ignore modifications and dismiss the edit mode
      apiRef.current.stopCellEditMode({ id, field, ignoreModifications: true });
    }
  };

  return (
    <div>
      {value}
      <SelectClientsDialog
        open
        allowSelectOnlyValid={false}
        onClose={handleClose}
        title="Choose representative life"
        queryParams={{ typeid: ClientType.Individual }}
      />
    </div>
  );
};

export default DataGridEditPartyRepresentativeCell;
